<template>
  <div class="btn-group">
    <button v-if="canEdit" class="btn btn-secondary btn-sm" @click="edit">
      <i class="fas fa-edit"></i>
    </button>
    <button v-if="canDelete" class="btn btn-danger btn-sm" @click="confirmDeleting">
      <i class="fas fa-trash-alt"></i>
    </button>
    <button v-if="canRestore" class="btn btn-success btn-sm" @click="confirmRestoring">
      <i class="fas fa-reply"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {boolean}
     */
    canEdit() {
      return ! this.isDeleted && this.row.canEdit;
    },

    /**
     * @return {boolean}
     */
    canDelete() {
      return ! this.isDeleted && this.row.canDelete;
    },

    /**
     * @return {boolean}
     */
    canRestore() {
      return this.isDeleted && this.row.canRestore;
    },

    /**
     * @return {boolean}
     */
    isDeleted() {
      return Boolean(this.row.model.is_deleted);
    },

    /**
     * @return {string}
     */
    editUrl() {
      return this.row.editUrl;
    },

    /**
     * @return {string}
     */
    deleteUrl() {
      return this.row.deleteUrl;
    },

    /**
     * @return {string}
     */
    restoreUrl() {
      return this.row.restoreUrl;
    },
  },

  methods: {
    /**
     * @event edit
     */
    edit() {
      this.$emit('edit', {row: this.row, url: this.editUrl});
    },

    /**
     * @event delete
     */
    confirmDeleting() {
      this.$confirm('Are you sure you want to delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => null);
    },

    /**
     * @event delete
     */
    confirmRestoring() {
      this.$confirm('Are you sure you want to restore this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('restore', {row: this.row, url: this.restoreUrl}))
          .catch(() => null);
    },
  },
}
</script>
